import { render, staticRenderFns } from "./GradeSelection.vue?vue&type=template&id=753f8a29&scoped=true"
import script from "./GradeSelection.vue?vue&type=script&lang=js"
export * from "./GradeSelection.vue?vue&type=script&lang=js"
import style0 from "./GradeSelection.vue?vue&type=style&index=0&id=753f8a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753f8a29",
  null
  
)

export default component.exports